import { render, staticRenderFns } from "./form-partial.vue?vue&type=template&id=28ba376d"
import script from "./form-partial.vue?vue&type=script&lang=js"
export * from "./form-partial.vue?vue&type=script&lang=js"
import style0 from "./form-partial.vue?vue&type=style&index=0&id=28ba376d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports